import { motion } from "framer-motion";
import { MapPin, Clock, Video, ArrowUpRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { PRACTICE } from "../data/site";

const HOURS = [
    { label: "Sessions", value: "By appointment" },
    { label: "Booking & forms", value: "Online anytime via Headway" },
    { label: "Telehealth", value: "Available for teens & adults" },
];

export default function Visit() {
    return (
        <div data-testid="visit-page" className="pb-28">
            <PageHeader
                testid="visit-header"
                breadcrumb="Location & Hours"
                title="Come find the warm light"
                number="08"
                label="Location & Hours"
                heading="Find the room with the warm light"
            >
                <div className="mt-10 overflow-hidden rounded-3xl ring-1 ring-amber-500/15">
                    <img
                        src="https://images.pexels.com/photos/6468883/pexels-photo-6468883.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                        alt="A cozy corner of the counseling office with soft chairs and warm light"
                        className="h-64 w-full object-cover sm:h-80"
                    />
                </div>

                <div className="mt-10 grid gap-6 lg:grid-cols-2">
                    <motion.div
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                        className="rounded-3xl border border-amber-500/15 bg-[#1F1510]/50 p-8"
                    >
                        <div className="flex items-center gap-2 text-amber-300">
                            <MapPin className="h-5 w-5" />
                            <span className="text-xs uppercase tracking-[0.25em]">
                                {PRACTICE.location}
                            </span>
                        </div>
                        <p className="mt-4 font-serif text-xl leading-relaxed text-amber-100">
                            {PRACTICE.address}
                        </p>
                        <a
                            href={PRACTICE.mapUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-6 inline-flex items-center gap-2 rounded-full border border-amber-500/40 px-6 py-3 text-sm font-semibold text-amber-100 transition-colors hover:border-amber-400 hover:bg-amber-500/10"
                        >
                            Get directions
                            <ArrowUpRight className="h-4 w-4" />
                        </a>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.08 }}
                        className="rounded-3xl border border-amber-500/15 bg-[#1F1510]/50 p-8"
                    >
                        <div className="flex items-center gap-2 text-amber-300">
                            <Clock className="h-5 w-5" />
                            <span className="text-xs uppercase tracking-[0.25em]">
                                Hours
                            </span>
                        </div>
                        <ul className="mt-5 space-y-3">
                            {HOURS.map((h) => (
                                <li
                                    key={h.label}
                                    className="flex items-center justify-between border-b border-amber-500/10 pb-3 text-sm last:border-b-0"
                                >
                                    <span className="text-amber-100/60">
                                        {h.label}
                                    </span>
                                    <span className="text-amber-100">
                                        {h.value}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </motion.div>
                </div>

                <div className="mt-10 flex items-start gap-4 rounded-3xl border border-amber-500/20 bg-[#281D17] p-8">
                    <Video className="mt-1 h-6 w-6 shrink-0 text-amber-400" />
                    <div>
                        <h3 className="font-serif text-xl text-amber-100">
                            Can't make it in?
                        </h3>
                        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-amber-100/65">
                            Secure telehealth sessions are available for teens
                            and adults. Little ones do their best work in the
                            playroom, in person — it's worth the trip.
                        </p>
                    </div>
                </div>
            </PageHeader>
        </div>
    );
}
